<template>
  <v-card flat class="pa-4">
    <v-card-item v-if="title && !$vuetify.display.mobile">
      <v-card-title class="text-h5 font-weight-regular">{{ title }}</v-card-title>
      <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  }
});
</script>